<template>
	<div>
		<div v-if="expedient.length">
			<v-row justify="start">
				<v-col cols="12" v-for="(item, i) in items" :key="i" class="mb-2 py-0">
					<v-card v-if="item.data" elevation="3" outlined flat max-width="600">
						<v-card-title :class="'mdi ' + iconPerson(item.type)" class="my-0 py-0">
							<span class="text--secondary caption pl-2"
								>{{ formatDate(item.date) }}
							</span>
						</v-card-title>
						<v-card-text class="text-left text--secondary py-0 my-0">
							<div v-if="item.type === 'check-in'">
								<span class="caption font-weight-bold d-block mx-2 py-1"
									>Check-in</span
								>
								<span class="caption">
									Hora de Entrada: {{ formatDate(item.data.in) }} <br />
									Temperatura: {{ item.data.temperature }}
								</span>
							</div>
							<div v-if="item.type === 'check-out'">
								<span class="caption font-weight-bold d-block mx-2 py-1"
									>Check-out</span
								>
								<span class="caption">
									Hora de Salida: {{ formatDate(item.data.out) }} <br />
									Ganado: ${{ item.data.earned }}
								</span>
								<span class="caption" v-if="item.data.delay != '-'">
									- Atraso: {{ item.data.delay }}
								</span>
								<span
									class="caption"
									v-if="item.data.extra != '-' || item.data.extra != '00:00'"
								>
									- Horas extra: {{ item.data.extra }}
								</span>
							</div>
							<div v-if="item.type === 'Creado'">
								<span class="date caption ">
									{{ formatDate(item.date) }}
								</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									Persona creada
								</span>
								<div class="mt-2 ma-2">
									<span class="caption">
										{{ item.data.firstName }}
										{{ item.data.lastName ? item.data.lastName : '' }}
										{{ item.data.rut ? item.data.rut : '' }}
									</span>
									<span class="caption">
										{{ item.data.phone ? `Telefono ${item.data.phone}` : '' }}
									</span>
									<span class="caption">
										{{
											item.data.birthdate
												? `Fecha de nacimiento ${item.data.birthdate}`
												: ''
										}}
									</span>
									<span class=" caption">
										{{ item.data.email ? item.data.email : '' }}
									</span>
								</div>
							</div>
							<div v-if="item.type === 'Actualizado'">
								<span class="date caption ">{{ formatDate(item.date) }}</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									{{ item.type }}
								</span>
								<div class="mt-2 ma-2">
									<div class="caption">
										{{ item.data.firstName }}
										{{ item.data.lastName ? item.data.lastName : '' }}
										{{ item.data.rut ? item.data.rut : '' }}
									</div>
									<div class="caption">
										{{ item.data.email ? `${item.data.email}` : '' }}
									</div>
									<div class="caption">
										{{ item.data.phone ? `Telefono ${item.data.phone}` : '' }}
									</div>
									<div class="caption">
										{{ item.data.region ? `Región ${item.data.region}` : '' }}
										{{ item.data.comuna ? `Comuna ${item.data.comuna}` : '' }}
									</div>
									<div class="caption">
										{{
											item.data.birthdate
												? `Fecha de nacimiento ${item.data.birthdate}`
												: ''
										}}
										{{ item.data.age ? `Edad ${item.data.age}` : '' }}
									</div>
									<div class="caption">
										{{
											item.data.function
												? `Función ${item.data.function}`
												: ''
										}}
									</div>
									<div class="caption">
										{{
											item.data.appointment
												? `Rol ${item.data.appointment}`
												: ''
										}}
									</div>
								</div>
							</div>
							<div v-if="item.type === 'Convertido'">
								<span class="date caption ">
									{{ formatDate(item.date) }}
								</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									{{ item.data.firstName }} Convertido a usuario
								</span>
							</div>
							<div v-if="item.type === 'Eliminado'">
								<span class="date caption ">
									{{ formatDate(item.date) }}
								</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									{{ item.type }}
								</span>
							</div>
							<div v-if="item.type === 'Position'">
								<span class="date caption">
									{{ formatDate(item.date) }}
								</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									{{ item.data.firstName }} ha actualizado su posición
								</span>
								<div class="mt-2 ma-4">
									<v-btn
										v-if="showMap !== i"
										small
										text
										@click="showMap = i"
										color="grey darken-2"
									>
										<v-icon>mdi-map</v-icon>
										Ver mapa
									</v-btn>
									<Geolocation
										v-if="showMap === i"
										:person="item.data"
										:id-map="`${item.date}`"
										:height-map="$vuetify.breakpoint.sm ? '250px' : '150px'"
									/>
									<v-btn
										v-if="showMap === i"
										text
										small
										class="mt-4"
										@click="showMap = ''"
									>
										Ocultar mapa
									</v-btn>
								</div>
							</div>
							<div v-if="item.type === 'Document'">
								<span class="date caption">
									{{ formatDate(item.date) }}
								</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									Actualización de documentos
								</span>
								<template v-for="(document, index) in item.data.documents">
									<v-chip
										v-if="document"
										link
										:href="document.url"
										small
										label
										:key="index"
										class="ma-2"
									>
										{{ document.type }}
									</v-chip>
								</template>
							</div>
							<div v-if="item.type === 'TypeDocument'">
								<span class="date caption">
									{{ formatDate(item.date) }}
								</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									Ha solicitado el documento "{{
										item.data.typeDocument[item.data.typeDocument.length - 1]
											.type
									}}"
								</span>
							</div>
							<div v-if="item.type === 'RemoveDocument'">
								<span class="date caption">
									{{ formatDate(item.date) }}
								</span>
								<span class="caption font-weight-bold d-block mx-2 py-1">
									{{
										item.data.deleteDocument.url
											? 'Ha eliminado el documento'
											: 'Ha cancelado la solicitud de documento'
									}}
									"{{ item.data.deleteDocument.type }}"
								</span>
							</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</div>
		<empty v-else title="Vacío" msj="Sin informacion" class="mt-4" />
		<!-- <v-pagination
			v-if="expedient.length"
			v-model="currentPage"
			:length="Math.ceil(expedient.length / 10)"
			:total-visible="5"
			@input="paginate"
		></v-pagination> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		Geolocation: () => import('@/components/audits/geolocation'),
		Empty: () => import('@/components/ui/DataEmpty'),
	},
	props: {
		expedient: {
			type: Array,
			default: () => [],
		},
		formatDate: {
			type: Function,
			required: true,
		},
		// paginator: {
		// 	type: Function,
		// 	required: true,
		// },
	},
	computed: {
		items() {
			return this.expedient.filter(el => moment(el.date).isSame(this.month, 'month'));
		},
		...mapGetters({
			month: 'Lodging/month',
		}),
	},
	data() {
		return {
			showMap: '',
			// currentPage: 1,
			// filterExpedient: [],
		};
	},
	// mounted() {
	// 	this.paginate();
	// },
	methods: {
		// paginate() {
		// 	this.filterExpedient = this.paginator(this.expedient, this.currentPage);
		// },
		iconPerson(type) {
			if (type === 'Creado') return 'mdi-account-plus';
			else if (type === 'Actualizado') return 'mdi-account-edit';
			else if (type === 'Convertido') return 'mdi-account-convert';
			else if (type === 'Eliminado') return 'mdi-account-minus';
			else if (type === 'Position') return 'mdi-map-marker-check';
			else if (type === 'Document') return 'mdi-text-box-plus';
			else if (type === 'RemoveDocument') return 'mdi-text-box-remove';
			else if (type === 'TypeDocument') return 'mdi-alert-circle';
			else if (type === 'check-in') return 'mdi-account-arrow-left-outline';
			else if (type === 'check-out') return 'mdi-account-arrow-right-outline';
		},
	},
};
</script>
